import React from 'react';

const About = () => (
  <div className="w-full">
    <h2 className="text-xl font-bold mb-2">About</h2>
    <p className="text-justify">Titan Validations is a comprehensive application designed to validate and analyze Titan rules.</p>
  </div>
);

export default About;
